import React from "react"

import { Icon, InfoFilled } from "@cgtrader/triangle-ui/dist/src/ssr-index"
import { bool } from "prop-types"

import useUseCaseTranslate from 'Pods/LazyLoaded/UseCaseAreaSidebar/hooks/useUseCaseTranslate'

function UseCasePermissionMessage({ isBuyerWithAnUseCase, isFreeModel, isDownloaded = false }) {
  const { tv } = useUseCaseTranslate()
  let message

  if (isBuyerWithAnUseCase) {
    message = tv('permission.alreadyPosted')
  } else if (isFreeModel && !isDownloaded) {
    message = tv('permission.downloadRequired')
  } else {
    message = tv('permission.purchaseRequired')
  }

  return (
    <div className="use-cases-area__needs-permission-container">
      <Icon svgComponent={InfoFilled} color="info" />
      <span>{message}</span>
    </div>
  )
}

UseCasePermissionMessage.propTypes = {
  isBuyerWithAnUseCase: bool.isRequired,
  isFreeModel: bool.isRequired,
  isDownloaded: bool,
}

export default UseCasePermissionMessage
